import { create } from 'zustand';

interface IHeaderStore {
  isChangePasswordModalOpen: boolean;
  openChangePasswordModal: () => void;
  closeChangePasswordModal: () => void;

  isUploadProfilePictureModalOpen: boolean;
  openUploadProfilePictureModal: () => void;
  closeUploadProfilePictureModal: () => void;

  isSwitchRolesModalOpen: boolean;
  openSwitchRolesModal: () => void;
  closeSwitchRolesModal: () => void;
}

export const useHeaderStore = create<IHeaderStore>((set) => ({
  isChangePasswordModalOpen: false,
  openChangePasswordModal: () => set(() => ({ isChangePasswordModalOpen: true })),
  closeChangePasswordModal: () => set(() => ({ isChangePasswordModalOpen: false })),

  isUploadProfilePictureModalOpen: false,
  openUploadProfilePictureModal: () => set(() => ({ isUploadProfilePictureModalOpen: true })),
  closeUploadProfilePictureModal: () => set(() => ({ isUploadProfilePictureModalOpen: false })),

  isSwitchRolesModalOpen: false,
  openSwitchRolesModal: () => set(() => ({ isSwitchRolesModalOpen: true })),
  closeSwitchRolesModal: () => set(() => ({ isSwitchRolesModalOpen: false })),
}));
